// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
  capitalizeFirstChar(): string;
}

// eslint-disable-next-line no-extend-native
String.prototype.capitalizeFirstChar = function (): string {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export function removeParentheses(str: string): string {
  if (!str) return '';
  return str.replace(/\s*\([^)]*\)\s*/g, '');
}
